module.exports = __webpack_public_path__ + "static/media/first-arrow.cfd90e47.png";